import { backendClient } from '../lib/api/backendClient';

type FeedbackCategory = 'broken' | 'confusing' | 'feature_or_improvement' | 'like' | 'other';

export type FeedbackPayload = {
  message: string;
  category?: FeedbackCategory;
  email?: string;
  route?: string;
  userId?: string | null;
  appVersion?: string;
  userAgent?: string;
};

type FeedbackResponse =
  | { success: true; id: string }
  | { success: false; error: string };

const submitFeedback = async (payload: FeedbackPayload): Promise<FeedbackResponse> => {
  const body: Record<string, any> = {};

  body.message = payload.message;

  if (payload.category) {
    body.category = payload.category;
  }
  if (payload.email) {
    body.email = payload.email;
  }
  if (payload.route) {
    body.route = payload.route;
  }
  if (payload.userId !== undefined) {
    body.userId = payload.userId;
  }
  if (payload.appVersion) {
    body.appVersion = payload.appVersion;
  }
  if (payload.userAgent) {
    body.userAgent = payload.userAgent;
  }

  const { data } = await backendClient.post<FeedbackResponse>('/api/feedback', body, {
    headers: { 'Content-Type': 'application/json' },
  });

  return data;
};

export const feedbackService = {
  submitFeedback,
};
